
import { authConstants } from "./constants/authConstants";
import { userConstants } from "./constants/userConstants";

const loginRequest = (data: any) => ({
  type: authConstants.userLoginRequest, payload: data
});


// Phone-based OTP login (send OTP)
const otpLoginRequest = (data: any) => ({
  type: authConstants.otpLoginRequest,
  payload: data,
});

const otpVerifyRequest = (data: any) => ({
  type: authConstants.otpVerifyRequest,
  payload: data,
});

// Resend OTP
const resendOtpRequest = (data: any) => ({
  type: authConstants.resendOtpRequest,
  payload: data,
});

const renewtokenRequest = (input:any) => ({
  type: authConstants.renewTokenRequest,
  payload: input,
});

// Logout clears auth-related state
const logout = () => ({
  type: authConstants.userLogout,
});

const verifyTokenRequest = (input:any) => ({
  type: authConstants.verifyTokenRequest,
  payload: input,
}); 


const acceptInvitationRequest = (input:any) => ({
  type: authConstants.acceptInvitationRequest,
  payload: input,
});

const registerTenantRequest = (input: any) => ({
  type: authConstants.registerTenantRequest,
  payload: input,
});

const verifyRegistrationRequest = (input: any) => ({
  type: authConstants.verifyRegistrationRequest,
  payload: input,
});

const checkTenantExistsRequest = (input: any) => ({
  type: authConstants.checkTenantExistsRequest,
  payload: input,
});


const authActions = {
  loginRequest,
  otpLoginRequest,
  resendOtpRequest,
  otpVerifyRequest,
  renewtokenRequest,
  acceptInvitationRequest,
  verifyTokenRequest,
  registerTenantRequest,
  verifyRegistrationRequest,
  checkTenantExistsRequest,
  logout,
};

export default authActions;